<template>
  <div id="add-topik">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group">
        <label for="add-nama">
          ID Aplikasi <span class="text-danger">*</span>
        </label>
        <div class="form-group input-group transparent">
          <input
            id="add-nama"
            type="text"
            v-model="app_id"
            placeholder="Masukan Nama Aplikasi"
            class="form-control rounded"
            required
          />
        </div>
      </div>
      <div class="form-group">
        <label for="add-nama">
          Nama Aplikasi <span class="text-danger">*</span>
        </label>
        <div class="form-group input-group transparent">
          <input
            id="add-nama"
            type="text"
            v-model="app_name"
            placeholder="Masukan Nama Aplikasi"
            class="form-control rounded"
            required
          />
        </div>
      </div>
      <div class="form-group">
        <label for="add-platform">
          Platform <span class="text-danger">*</span>
        </label>
        <div class="form-group input-group transparent">
          <select
            id="add-platform"
            v-model="platform"
            class="form-control rounded"
            style="height: 2.2rem !important"
            required
          >
            <option value="" disabled selected>Pilih Platform</option>
            <option value="playstore">Play Store</option>
            <option value="appstore">App Store</option>
          </select>
        </div>
      </div>
      <div class="form-group" id="add-topik-modal-select">
        <label for="inputTopik">
          Nama Topik <span class="text-danger">*</span>
        </label>
        <select
          name="topik"
          id="selectTopik"
          v-model="selected_topic"
          class="form-control"
        ></select>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary" :disabled="is_loading">
          Simpan
        </button>
      </div>
      <floating-loader-component v-if="is_loading" />
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import floating_loader from "@/views/components/floating_loader.vue";

$.pgNotification = notif;
export default {
  name: "modal_adit_apps",
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      err: null,
      selected_topic: this.data["topic"],
      selected_tipe: null,
      app_id: this.data["app_id"],
      app_name: this.data["app_name"],
      platform: this.data["platform"],
      is_loading: false,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      tipe:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.project.project_detail.tipe
          : this.data[0]["tipe_project"],
    };
  },
  methods: {
    getTopic: function () {
      let self = this;
      let api =
        process.env.VUE_APP_API_URL + "display-topics/" + this.id_project;
      this.is_loading = true;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status != 204) {
            let data = {};
            let topic_list =
              self.tipe == 1 ? response.data.socmed : response.data.formed;
            for (let topic in topic_list) {
              data = {
                id: topic,
                text: topic_list[topic],
              };
              let newOption = new Option(data.text, data.id, false, false);
              $("#selectTopik").append(newOption);
            }
            $("#selectTopik").val(self.selected_topic);
            $("#selectTopik").trigger("change");
            self.is_loading = false;
          }
        })
        .catch(function (err) {
          self.err = err.response;
        })
        .finally(function () {
          $("#selectTopik")
            .select2({
              width: "100%",
            })
            .on("change", function () {
              self.selectTopic(this.value);
            });
        });
    },
    selectTopic: function (value) {
      this.selected_topic = value;
    },
    submitForm: function () {
      let self = this;
      self.$store.dispatch("loading", true);
      let params = {
        app_id: this.$sanitize(this.app_id),
        app_name: this.$sanitize(this.app_name),
        platform: this.platform,
        id_project: this.id_project,
        topic: this.selected_topic,
      };
      let api =
        process.env.VUE_APP_API_URL + "review/update-apps/" + this.data["_id"];
      this.is_loading = true;
      this.$http
        .put(api, params)
        .then(function (response) {
          if (response.status == 200) {
            self.topik = null;
            $("#modalSlideUp").modal("hide");
            self.$parent.$parent.getData();
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Aplikasi berhasil diupdate!',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
            self.$store.dispatch("loading", false);
          } else {
            $("#modalSlideUp").modal("hide");
            self.$store.dispatch("loading", false);
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                  response.data.status,
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          }
        })
        .catch(function (error) {
          self.$store.dispatch("loading", false);
          $("#modalSlideUp").modal("hide");

          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                error.response.data.status,
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          self.$store.dispatch("loading", false);
          this.is_loading = false;
        });
    },
  },
  mounted: function () {
    let self = this;
    $(function () {
      self.getTopic();
    });
  },
};
</script>

<style scoped>
.form-control select {
  -webkit-appearance: button;
  cursor: pointer;
}
</style>
